import { render, staticRenderFns } from "./DialogLegalPersonalData.vue?vue&type=template&id=3a4f96df&scoped=true"
import script from "./DialogLegalPersonalData.vue?vue&type=script&lang=js"
export * from "./DialogLegalPersonalData.vue?vue&type=script&lang=js"
import style0 from "./DialogLegalPersonalData.vue?vue&type=style&index=0&id=3a4f96df&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a4f96df",
  null
  
)

export default component.exports